import React, { useContext } from 'react'
import _ from 'lodash'
import { useForm, Controller } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { v4 } from 'uuid'

import { StepContext } from '../../../../containers/contexts'
import actionMeta from '../meta.json'
import ToggleSwitch from '../../../../components/Toggle'
import { addAction, updateAction } from 'Actions/flow'

const ZapierTrigger = (props) => {
  const { mode = 'edit', createActionType, actionId, cancelFn = _.noop, deleteFn = _.noop } = props

  const isEditMode = mode === 'edit'

  const dispatch = useDispatch()
  const { step, stepId } = useContext(StepContext)
  const settings = _.get(step, 'settings', {})

  const action = _.get(settings, `${actionId}`, {
    type: createActionType
  })

  const { control, handleSubmit } = useForm({
    defaultValues: {
      waitForResponse: action.waitForResponse ?? false
    }
  })

  const createAction = (data) => {
    dispatch(
      addAction({
        stepId,
        actionId: v4(),
        setting: {
          type: action.type,
          waitForResponse: data.waitForResponse
        }
      })
    )

    cancelFn()
  }

  const editAction = (data) => {
    dispatch(
      updateAction({
        stepId,
        actionId,
        setting: {
          type: action.type,
          waitForResponse: data.waitForResponse
        }
      })
    )
    cancelFn()
  }

  const onSubmit = (data) => {
    if (mode === 'create') {
      createAction(data)
    } else {
      editAction(data)
    }

    cancelFn()
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className='form-group'>
        <div className='label'>{actionMeta[action.type].name}</div>
      </div>
      <div className='form-group d-flex'>
        <div className='label'>Wait for response from Zapier</div>
        <Controller
          name='waitForResponse'
          control={control}
          render={({ field: { value, onChange } }) => {
            return (
              <ToggleSwitch
                className='ml-auto'
                checked={value}
                onClick={() => {
                  onChange(!value)
                }}
              />
            )
          }}
        />
      </div>
      <div className='options'>
        <button className='button-primary small save' type='submit'>
          Save
        </button>
        <button className='btn cancel' onClick={cancelFn} type='button'>
          Cancel
        </button>
        {isEditMode && (
          <button className='btn delete' type='button' onClick={deleteFn}>
            Delete
          </button>
        )}
      </div>
    </form>
  )
}

export default ZapierTrigger
